module.exports = __webpack_public_path__ + "static/media/create-account.4eab4f45.png";